import { DOCUMENT_TYPES } from '../../../constants/purchase';
import { PurchaseDetail, PurchaseFormValues } from '../../../types/purchases/BasePurchase';
import { mapCreditNote } from './creditNoteMapper';
import { mapDebitNote } from './debitNoteMapper';
import { mapDefaultPurchase } from './defaultMapper';
import { mapExcludedSubject } from './excludedSubjectMapper';
import { mapImportPurchase } from './importMapper';
import { mapTaxCredit } from './taxCreditMapper';


export function mapPurchaseResponseToFormValues(purchase: PurchaseDetail): PurchaseFormValues {
  const typeId = purchase.documentType?.id;

  switch (typeId) {
    case DOCUMENT_TYPES.TAX_CREDIT:
      return mapTaxCredit(purchase);
    case DOCUMENT_TYPES.CREDIT_NOTE:
      return mapCreditNote(purchase);
    case DOCUMENT_TYPES.IMPORT:
      return mapImportPurchase(purchase);
    case DOCUMENT_TYPES.EXCLUDED_SUBJECT:
      return mapExcludedSubject(purchase);
    case DOCUMENT_TYPES.DEBIT_NOTE:
      return mapDebitNote(purchase);
    case DOCUMENT_TYPES.INVOICE:
    case DOCUMENT_TYPES.TICKET:
    default:
      return mapDefaultPurchase(purchase);
  }
}
